import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon } from '../../../config/variables';
import { getMedia, hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { IMediaItem, ITableContainerProps } from '../../../types/Interfaces';
import { IVehicleMake } from '../types/interfaces';

const VehicleMakesTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<IVehicleMake[]>) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  function getLogo(data: IMediaItem[]) {
    const coloredLogo = getMedia(data, 'logo');
    if (coloredLogo) return coloredLogo?.url;
    const blackLogo = getMedia(data, 'logo_black');
    if (blackLogo) return blackLogo?.url;
    const whiteLogo = getMedia(data, 'logo_white');
    if (whiteLogo) return whiteLogo?.url;
  }

  const hasEditPermission = hasPermission(['specs_groups.edit'])

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header, index) =>
          !header ? null : (
            <span className={`head ${header.customClass}`} key={index}>
              {header.label}
            </span>
          )
        )}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item, index) => (
              <div
                className={`item has_big_logo ${hasEditPermission && 'clickable'} vehicle_makes`}
                key={index}
                onClick={(e) => {
                  hasEditPermission && navigateRoute(e, `/vehicle-makes/create-vehicle-make/${item.id}`, navigate);
                }}
              >
                <div className="column">
                  <div className="large-icon-container">{item?.media && getLogo(item?.media) ? <img src={getLogo(item?.media)} alt="" /> : '-'}</div>
                </div>
                <div className="column">
                  <div className="capitalize">{item?.name || '-'}</div>
                </div>
                {hasEditPermission && (
                  <div className="column actions actions_col">
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/vehicle-makes/create-vehicle-make/${item.id}`, navigate);
                      }}
                    >
                      {editIcon}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default VehicleMakesTableContainer;
